// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qjti1","content":"styles_content__2-ZoI","row":"styles_row__3AQlv","footer":"styles_footer__F1vgq","phraseLength":"styles_phraseLength__3BYCS"};